import { motion } from "framer-motion";
import { Eyebrow, MaskLines } from "../components/Motion";

const steps = [
  { n: "01", t: "Request online", d: "Pick laptop or desktop, describe the fault and add photos. You get a WT- reference number instantly." },
  { n: "02", t: "Hand it over", d: "We pick it up from you Monday to Friday, 7am to 6pm, or you post it to us." },
  { n: "03", t: "Diagnose & quote", d: "We find the fault and contact you the way you prefer — email, phone or text — before any work starts." },
  { n: "04", t: "Fixed & returned", d: "Follow each stage with your reference number until your machine is ready." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative border-t border-white/[0.06] bg-slab/40">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:px-10 md:py-36 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow>02 — How it works</Eyebrow>
          <MaskLines className="mt-5 font-display text-4xl font-black uppercase leading-[0.92] tracking-tight sm:text-5xl lg:text-7xl" lines={["Four steps.", "No guesswork."]} />
          <p className="mt-8 max-w-sm text-slate-300">One reference number follows your machine from the moment you submit until it's back in your hands.</p>
        </div>
      </div>
      <ol className="lg:col-span-7">
        {steps.map((s, i) => (
          <motion.li
            key={s.n}
            data-testid={`process-step-${s.n}`}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 }}
            className="group grid grid-cols-[auto_1fr] gap-6 border-b border-white/[0.08] py-10 md:gap-10"
          >
            <span className="font-mono text-sm text-ember">{s.n}</span>
            <div>
              <h3 className="font-display text-3xl font-extrabold tracking-tight transition-transform duration-500 group-hover:translate-x-2 md:text-5xl">{s.t}</h3>
              <p className="mt-4 max-w-lg text-slate-300">{s.d}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
